import React from 'react';
import PlatformIcon from './PlatformIcon';
import { countryCodeToFlagEmoji } from '../utils/countryFlag';

const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.8 4 6 4 9s-1.5 6.2-4 9M12 3c-2.5 2.8-4 6-4 9s1.5 6.2 4 9" />
  </svg>
);

const TickerSectionMarker = ({ section }) => {
  const isGlobal = section.scope === 'global';
  const countryFlag = !isGlobal ? countryCodeToFlagEmoji(section.countryCode) : null;
  const platformLabel = section.platform === 'twitch'
    ? 'Twitch'
    : section.platform === 'youtube'
      ? 'YouTube'
      : section.platform === 'kick'
        ? 'Kick'
        : null;

  return (
    <span
      className={`ticker-section-marker${isGlobal ? ' ticker-section-marker--global' : ' ticker-section-marker--country'}`}
      aria-label={section.label}
    >
      <span className="ticker-section-icon">
        {isGlobal ? (
          section.platform ? (
            <PlatformIcon platform={section.platform} />
          ) : (
            <GlobeIcon />
          )
        ) : (
          countryFlag || section.countryCode
        )}
      </span>
      <span className="ticker-section-text">
        <span className="ticker-section-label">{section.label}</span>
        {platformLabel && (
          <span className="ticker-section-sub">{platformLabel} · Top 10</span>
        )}
      </span>
    </span>
  );
};

export default TickerSectionMarker;
